import React from 'react'
import { Box, Button, TextField, Paper, FormControlLabel, Checkbox, MenuItem } from '@mui/material'
import { Grid } from '@mui/material'
import { router, usePage, useForm } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Form.layout = (page) => <AppShell>{page}</AppShell>

export default function Form({ property, cost_category, distribution_keys = [], action, errors: serverErrors = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const isEdit = action === 'edit'
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  const { data, setData, post, put, processing, errors } = useForm({
    name: cost_category.name || '',
    slug: cost_category.slug || '',
    allocatable: cost_category.allocatable !== false,
    heating_related: cost_category.heating_related || false,
    group: cost_category.group || '',
    position: cost_category.position || '',
    distribution_key_id: cost_category.distribution_key_id || '',
  })

  const allErrors = { ...serverErrors, ...errors }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isEdit) {
      put(`${basePath}/cost_categories/${cost_category.id}`)
    } else {
      post(`${basePath}/cost_categories`)
    }
  }

  return (
    <Box>
      <PageHeader
        title={isEdit ? 'Kostenkategorie bearbeiten' : 'Neue Kostenkategorie'}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Kostenkategorien', href: `${basePath}/cost_categories` },
          { label: isEdit ? 'Bearbeiten' : 'Neu' },
        ]}
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider', maxWidth: 600 }}>
        <Box component="form" onSubmit={handleSubmit} data-testid="cost-category-form">
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField label="Name" required fullWidth size="small"
                value={data.name} onChange={(e) => setData('name', e.target.value)}
                error={!!allErrors.name} helperText={allErrors.name?.[0]}
                data-testid="name-input" />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Slug" fullWidth size="small"
                value={data.slug} onChange={(e) => setData('slug', e.target.value)}
                error={!!allErrors.slug} helperText={allErrors.slug?.[0] || 'Wird automatisch aus dem Namen generiert wenn leer'}
                data-testid="slug-input" />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Gruppe" fullWidth size="small"
                value={data.group} onChange={(e) => setData('group', e.target.value)}
                data-testid="group-input" />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField label="Position" fullWidth size="small" type="number"
                value={data.position} onChange={(e) => setData('position', e.target.value)}
                data-testid="position-input" />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                select
                label="Verteilschlüssel"
                fullWidth
                size="small"
                value={data.distribution_key_id}
                onChange={(e) => setData('distribution_key_id', e.target.value)}
                data-testid="distribution-key-select"
              >
                <MenuItem value="">Kein Verteilschlüssel</MenuItem>
                {distribution_keys.map((dk) => (
                  <MenuItem key={dk.id} value={dk.id}>{dk.name}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControlLabel
                control={
                  <Checkbox checked={data.allocatable}
                    onChange={(e) => setData('allocatable', e.target.checked)}
                    data-testid="allocatable-checkbox" />
                }
                label="Umlagefähig"
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControlLabel
                control={
                  <Checkbox checked={data.heating_related}
                    onChange={(e) => setData('heating_related', e.target.checked)}
                    data-testid="heating-related-checkbox" />
                }
                label="Heizungskosten"
              />
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button type="submit" variant="contained" disabled={processing} data-testid="submit-btn">
              {processing ? 'Wird gespeichert...' : 'Speichern'}
            </Button>
            <Button variant="outlined" onClick={() => router.visit(`${basePath}/cost_categories`)}>Abbrechen</Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
